import type { AdvancedTableFilterOption } from '@zg-rentals/advanced-table';
import type { InvoiceItemFilters } from '../../model/InvoiceItemFilters';
import type { AdproductsZuoraBillingInvoiceDto } from '@zg-rentals/ts-adproducts-client';

const mapValues = (set: Set<string>): Array<AdvancedTableFilterOption> =>
  Array.from(set)
    .sort()
    .map((item) => ({
      label: item,
      isChecked: false,
    }));

export const calculateFilters = (invoice: AdproductsZuoraBillingInvoiceDto) => {
  if (!invoice) return {};
  const { zuoraInvoiceItems: invoiceItems } = invoice;
  if (!invoiceItems) return {};
  const filters: InvoiceItemFilters = {};
  const propertySet = new Set<string>();
  const productSet = new Set<string>();
  const citySet = new Set<string>();
  const stateSet = new Set<string>();
  invoiceItems.forEach((item) => {
    if (item.propertyName) propertySet.add(item.propertyName);
    if (item.chargeName) productSet.add(item.chargeName);
    if (item.city) citySet.add(item.city);
    if (item.state) stateSet.add(item.state);
  });
  if (propertySet.size > 1) {
    filters.propertyName = {
      title: 'Property',
      value: mapValues(propertySet),
      type: 'MULTISELECT',
    };
  }
  if (productSet.size > 1) {
    filters.chargeName = {
      title: 'Charge Item',
      value: mapValues(productSet),
      type: 'MULTISELECT',
    };
  }
  if (citySet.size > 1) {
    filters.city = {
      title: 'City',
      value: mapValues(citySet),
      type: 'MULTISELECT',
    };
  }
  if (stateSet.size > 1) {
    filters.state = {
      title: 'State',
      value: mapValues(stateSet),
      type: 'MULTISELECT',
    };
  }
  return filters;
};
